import type {Action} from "redux";
import type Popup from "../objects/Popup";

export const OPEN_POPUP = Symbol("CREATE_POPUP");
export const CLOSE_POPUP = Symbol("CLOSE_POPUP");

export interface IPopupState {
    popups: Popup[]
}

export interface IPopupAction extends Action<symbol> {
    popup: Popup
}

const initialState: IPopupState = {
    popups: []
};

export default function PopupReducer(state: IPopupState = initialState, action: IPopupAction): IPopupState {
    switch(action.type) {
        case OPEN_POPUP:
            return {
                ...state,
                popups: [...state.popups, action.popup]
            };
        case CLOSE_POPUP:
            return {
                ...state,
                popups: state.popups.filter(popup => popup !== action.popup)
            };
        default:
            return state;
    }
}